const hasMoreFeaturedNews = (locale: string) => locale && ([
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IE',
  'en-IN',
  'en-NZ',
  'en-US',
  'es-AR',
  'es-CL',
  'es-CO',
  'es-ES',
  'es-MX',
  'es-PE',
  'ja-JP',
  'ru-RU',
  'zh-CN',
].includes(locale));

const hasMoreNews = (newsboard: string) => newsboard && !([
  'FASHIONUNITED_INFO',
  'FASHIONUNITED_CN',
  'FASHIONUNITED_JP',
].includes(newsboard));

export default hasMoreFeaturedNews;
export { hasMoreNews };
